import React from 'react';
import { GiftIcon, SparklesIcon, CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function BonusSection() {
  const handleBuyClick = () => {
    // Track InitiateCheckout event when buy button is clicked
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        value: 67.0,
        currency: 'USD',
        content_name: 'Meta Ads Desde Cero',
        content_category: 'Course'
      });
    }
  };
  return <section id="pricing" className="w-full bg-gradient-to-b from-blue-50 via-white to-blue-50 py-16 md:py-24" data-id="element-26">
      <div className="max-w-6xl mx-auto px-6" data-id="element-27">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-28">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-29">
            Inversión y Bonos Incluidos
          </h2>
          <p className="text-xl text-gray-600" data-id="element-30">
            Todo lo que necesitas para empezar con Meta Ads
          </p>
        </div>

        {/* Pricing Card */}
        <div className="max-w-3xl mx-auto mb-12" data-id="element-31">
          <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-[#0866FF]" data-id="element-32">
            {/* Image */}
            <div className="relative" data-id="element-33">
              <img src="https://cdn.magicpatterns.com/uploads/jEe5Evf6YkSeLFxXEcPMML/ChatGPT_Image_3_dic_2025,_10_46_37_p.m..png" alt="Meta Ads Desde Cero - Curso completo" className="w-full h-auto" data-id="element-34" />
              <div className="absolute top-4 right-4 bg-red-500 text-white px-4 py-2 rounded-full font-bold text-sm shadow-lg" data-id="element-35">
                OFERTA LIMITADA
              </div>
            </div>

            {/* Pricing Content */}
            <div className="p-8 md:p-10 text-center" data-id="element-36">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-37">
                META ADS DESDE CERO
              </h3>
              <p className="text-lg text-gray-600 mb-8" data-id="element-38">
                Curso en vivo + Grabaciones + Soporte + 2 Bonos
              </p>

              {/* Price Comparison */}
              <div className="mb-8" data-id="element-39">
                <div className="flex items-center justify-center gap-3 mb-4" data-id="element-40">
                  <span className="text-2xl text-gray-400 line-through" data-id="element-41">
                    $250 USD
                  </span>
                  <span className="bg-red-500 text-white px-3 py-1 rounded-full text-sm font-bold" data-id="element-42">
                    -73%
                  </span>
                </div>
                <div className="flex items-baseline justify-center gap-2" data-id="element-43">
                  <span className="text-gray-600 text-xl" data-id="element-44">Hoy solo</span>
                  <span className="text-5xl md:text-6xl font-extrabold text-[#0866FF]" data-id="element-45">
                    $67
                  </span>
                  <span className="text-gray-600 text-xl" data-id="element-46">USD</span>
                </div>
                <p className="text-sm text-gray-500 mt-3" data-id="element-47">
                  Pago único • Acceso inmediato • Sin suscripciones
                </p>
              </div>

              {/* What's Included */}
              <div className="bg-blue-50 rounded-2xl p-6 mb-6" data-id="element-48">
                <p className="font-semibold text-gray-900 mb-4" data-id="element-49">Incluye:</p>
                <ul className="space-y-2 text-left" data-id="element-50">
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-51">
                    <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-52" />
                    4 módulos en vivo paso a paso
                  </li>
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-53">
                    <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-54" />
                    Grabaciones de todas las clases
                  </li>
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-55">
                    <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-56" />
                    Ejercicios prácticos para tu cuenta
                  </li>
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-57">
                    <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-58" />
                    Soporte en grupo
                  </li>
                  <li className="flex items-center gap-2 text-gray-700" data-id="element-59">
                    <CheckIcon className="w-5 h-5 text-green-600 flex-shrink-0" data-id="element-60" />
                    2 bonos con IA (ver abajo)
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bonos Section */}
        <div className="mb-12" data-id="element-61">
          <div className="grid md:grid-cols-2 gap-6" data-id="element-62">
            {/* BONO 1 - Condensed with Image */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg border-2 border-purple-200" data-id="element-63">
              <div className="flex items-start justify-between p-4 bg-purple-50" data-id="element-64">
                <div className="flex items-center gap-2" data-id="element-65">
                  <SparklesIcon className="w-5 h-5 text-purple-600" data-id="element-66" />
                  <span className="text-purple-600 font-bold text-sm" data-id="element-67">
                    BONO 1
                  </span>
                </div>
                <div className="text-right" data-id="element-68">
                  <p className="text-sm text-gray-400 line-through" data-id="element-69">$97 USD</p>
                  <span className="bg-green-500 text-white px-3 py-1 rounded-full text-xs font-bold" data-id="element-70">
                    HOY GRATIS
                  </span>
                </div>
              </div>

              {/* Bonus Image */}
              <div className="px-4 pt-4" data-id="element-71">
                <img src="https://cdn.magicpatterns.com/uploads/2QJ4RS4eMirnCqVYQRB5Ld/meta_ads_bono_1.png" alt="Creativos Publicitarios con IA" className="w-full h-auto rounded-lg" data-id="element-72" />
              </div>

              <div className="p-6" data-id="element-73">
                <h4 className="text-lg font-bold text-gray-900 mb-3" data-id="element-74">
                  Creativos Publicitarios con IA
                </h4>

                <ul className="space-y-2 mb-4" data-id="element-75">
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-76">
                    <CheckIcon className="w-4 h-4 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-77" />
                    Prompts listos para ganchos y textos
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-78">
                    <CheckIcon className="w-4 h-4 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-79" />
                    Guía para crear imágenes con IA
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-80">
                    <CheckIcon className="w-4 h-4 text-purple-600 flex-shrink-0 mt-0.5" data-id="element-81" />
                    Checklist de buen anuncio
                  </li>
                </ul>

                <div className="bg-purple-50 rounded-lg p-3 border-l-4 border-purple-500" data-id="element-82">
                  <p className="text-xs text-purple-900 font-medium" data-id="element-83">
                    Produce creativos probados sin diseñador
                  </p>
                </div>
              </div>
            </div>

            {/* BONO 2 - Condensed with Image */}
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg border-2 border-blue-200" data-id="element-84">
              <div className="flex items-start justify-between p-4 bg-blue-50" data-id="element-85">
                <div className="flex items-center gap-2" data-id="element-86">
                  <SparklesIcon className="w-5 h-5 text-blue-600" data-id="element-87" />
                  <span className="text-blue-600 font-bold text-sm" data-id="element-88">
                    BONO 2
                  </span>
                </div>
                <div className="text-right" data-id="element-89">
                  <p className="text-sm text-gray-400 line-through" data-id="element-90">$97 USD</p>
                  <span className="bg-green-500 text-white px-3 py-1 rounded-full text-xs font-bold" data-id="element-91">
                    HOY GRATIS
                  </span>
                </div>
              </div>

              {/* Bonus Image */}
              <div className="px-4 pt-4" data-id="element-92">
                <img src="https://cdn.magicpatterns.com/uploads/r4cTXkmCGmWp6JUGagcotN/img_bono_2_meta_ads.png" alt="Landing Express con IA" className="w-full h-auto rounded-lg" data-id="element-93" />
              </div>

              <div className="p-6" data-id="element-94">
                <h4 className="text-lg font-bold text-gray-900 mb-3" data-id="element-95">
                  Landing Express con IA
                </h4>

                <ul className="space-y-2 mb-4" data-id="element-96">
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-97">
                    <CheckIcon className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-98" />
                    Estructura de landing que convierte
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-99">
                    <CheckIcon className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-100" />
                    Prompts para titulares y CTAs
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-101">
                    <CheckIcon className="w-4 h-4 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-102" />
                    Sin necesidad de desarrollador
                  </li>
                </ul>

                <div className="bg-blue-50 rounded-lg p-3 border-l-4 border-blue-500" data-id="element-103">
                  <p className="text-xs text-blue-900 font-medium" data-id="element-104">
                    Landing funcional para enviar tráfico
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Total Value - More Eye-Catching */}
          <div className="mt-8 text-center" data-id="element-105">
            <div className="inline-block relative" data-id="element-106">
              {/* Glow effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 rounded-2xl blur-xl opacity-50" data-id="element-107"></div>

              {/* Main card */}
              <div className="relative bg-gradient-to-br from-blue-400 via-blue-500 to-blue-600 rounded-2xl px-10 py-6 shadow-2xl" data-id="element-108">
                <p className="text-sm text-white/90 font-semibold mb-2" data-id="element-109">
                  Valor total del paquete:
                </p>
                <div className="flex items-center justify-center gap-4 mb-2" data-id="element-110">
                  <span className="text-3xl line-through text-white/70 font-bold" data-id="element-111">
                    $444
                  </span>
                  <span className="text-5xl font-extrabold text-white drop-shadow-lg" data-id="element-112">
                    $67
                  </span>
                </div>
                <div className="bg-white/20 backdrop-blur rounded-full px-4 py-2 inline-block" data-id="element-113">
                  <p className="text-sm font-bold text-white" data-id="element-114">
                    🎉 Ahorras $377 USD hoy
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Final CTA */}
        <div className="text-center" data-id="element-115">
          <div className="bg-white rounded-2xl p-8 mb-6 border-2 border-gray-200" data-id="element-116">
            <p className="text-gray-900 text-xl font-semibold mb-4" data-id="element-117">
              ¿Listo para dominar Meta Ads desde cero?
            </p>
            <p className="text-gray-600 mb-6" data-id="element-118">
              Plazas limitadas • Precio especial termina pronto
            </p>
            <a id="buy-button" href="https://buy.stripe.com/4gMbITbn49tZ85kcYV6AM01" target="_blank" rel="noopener noreferrer" onClick={handleBuyClick} data-id="element-119">
              <CTAButton size="large" data-id="element-120">
                Sí, Quiero Unirme Ahora por $67 →
              </CTAButton>
            </a>
          </div>
          <p className="text-sm text-gray-500" data-id="element-121">
            🔒 Pago seguro • Acceso inmediato • Garantía de satisfacción
          </p>
        </div>
      </div>
    </section>;
}